/*
 * Impulse Theme - Sticky Add to Cart
 *
 * The sticky button submits the existing product form instead of
 * creating a second cart implementation. This preserves Impulse's
 * variant handling, AJAX cart and cart drawer behavior.
 */

(function () {
  'use strict';

  function initStickyATC() {
    var sticky = document.querySelector('[data-sticky-atc]');

    if (!sticky || sticky.dataset.initialized === 'true') {
      return;
    }

    sticky.dataset.initialized = 'true';

    var stickyButton = sticky.querySelector('[data-sticky-atc-button]');
    var stickyPrice = sticky.querySelector('[data-sticky-atc-price]');

    if (!stickyButton) {
      return;
    }

    /*
     * Impulse/product form compatibility:
     * Find the product form that submits to /cart/add.
     */
    var productForm = document.querySelector(
      'form[action*="/cart/add"]'
    );

    if (!productForm) {
      return;
    }

    var originalButton = productForm.querySelector(
      'button[type="submit"], input[type="submit"]'
    );

    if (!originalButton) {
      return;
    }

    /*
     * Show the sticky bar only after the original Add to Cart
     * button has left the viewport.
     */
    if ('IntersectionObserver' in window) {
      var intersectionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              sticky.classList.remove('is-visible');
            } else {
              sticky.classList.add('is-visible');
            }
          });
        },
        {
          threshold: 0
        }
      );

      intersectionObserver.observe(originalButton);
    } else {
      /*
       * Fallback for browsers without IntersectionObserver.
       */
      function fallbackVisibility() {
        var rect = originalButton.getBoundingClientRect();
        var visible =
          rect.top < window.innerHeight &&
          rect.bottom > 0;

        sticky.classList.toggle('is-visible', !visible);
      }

      window.addEventListener('scroll', fallbackVisibility, {
        passive: true
      });

      fallbackVisibility();
    }

    function getVariantInput() {
      return productForm.querySelector(
        'input[name="id"], select[name="id"]'
      );
    }

    function syncButtonState() {
      var variantInput = getVariantInput();

      if (!variantInput || !variantInput.value) {
        stickyButton.disabled = true;
        stickyButton.textContent = 'Unavailable';
        return;
      }

      var isDisabled =
        originalButton.disabled ||
        originalButton.getAttribute('aria-disabled') === 'true';

      stickyButton.disabled = isDisabled;

      if (isDisabled) {
        stickyButton.textContent = 'Sold Out';
      } else {
        stickyButton.textContent = 'Add to Cart';
      }
    }

    /*
     * Submit through Impulse's original Add to Cart button.
     */
    stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled) {
        return;
      }

      if (typeof productForm.requestSubmit === 'function') {
        productForm.requestSubmit(originalButton);
      } else {
        originalButton.click();
      }
    });

    /*
     * Keep the sticky button synced when Impulse changes
     * the selected variant / availability.
     */
    var variantInput = getVariantInput();

    if (variantInput) {
      variantInput.addEventListener('change', syncButtonState);

      if ('MutationObserver' in window) {
        var variantObserver = new MutationObserver(syncButtonState);

        variantObserver.observe(variantInput, {
          attributes: true,
          attributeFilter: ['value']
        });
      }
    }

    if ('MutationObserver' in window) {
      var buttonObserver = new MutationObserver(syncButtonState);

      buttonObserver.observe(originalButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
    }

    syncButtonState();
  }

  /*
   * Standard Shopify page load.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }

  /*
   * Useful when Shopify/Impulse dynamically replaces sections.
   */
  document.addEventListener('shopify:section:load', initStickyATC);
})();
